import type { RootStoreState } from "@store/types";
import { createSelector } from "reselect";

import { getConfig } from "@jti/fe-common";
import type { PostCodeConfig } from "@jti/magento";

const getStoreConfig = (state: RootStoreState) => state.cart?.storeConfig;

export const selectPostCodeConfig = createSelector([getStoreConfig], (storeConfig): PostCodeConfig => {
  const { HIDE_POST_CODE_INPUT, postCodeKeyboardType } = getConfig();

  const validationEnabled = storeConfig?.postcode_validation_enabled;
  const isRequired = storeConfig?.postcode_is_required;

  const shouldHidePostCode = /true/i.test(HIDE_POST_CODE_INPUT) && !isRequired;

  return {
    postcode_is_required: isRequired,
    postcode_max_length: storeConfig?.postcode_max_length,
    postcode_min_length: storeConfig?.postcode_min_length,
    postcode_validate_regex: storeConfig?.postcode_validate_regex,
    postcode_validation_enabled: validationEnabled,
    shouldHidePostCode: shouldHidePostCode,
    postCodeKeyboardType: postCodeKeyboardType ?? "default",
  };
});
